export default "__VITE_PUBLIC_ASSET__49f6edce__"